/* Nélya Paris — bloc bundle + Releasit COD Form. Reprise à l'identique de la méthode « bundle Releasit » (Oxyvia :
   initBuyBox, releasit, releasitPacks, avec tous les correctifs B1 à B12), adaptée à Nélya :
   - nuances = variantes (SKU NELYA-COFFRET-BRUN / -GRIS) : le SEUL input name="id" du formulaire porte la variante de la
     nuance choisie et suit chaque changement de nuance (B1 : Releasit lit le premier name="id") ;
   - lots 1 / 2 / 3 = offres de quantité Releasit (quantité = name="quantity"), sélectionnées par QUANTITÉ à chaque
     ouverture, y compris le lot 1 et les réouvertures ; vérification au ban près (quantité ET total) ;
   - prix au format de la boutique (« 159,99 lei », NelyaCore.formatMoney) ; classes d'état nelya-qo-pending / -show ;
   - changement de nuance après une 1ʳᵉ ouverture : Releasit garde, dans la page, la nuance de chaque set de l'offre
     (seul le 1ᵉʳ suit) et enverrait un mélange (ex. 1 Gri + 2 Maro). Pour un lot de 2 ou 3, si une autre nuance a déjà
     été ouverte dans la page, « Comandă » recharge la page avec la nuance (?variant=) et le lot (nelya_lot), puis rouvre
     le formulaire (nelya_commander) une fois la page chargée : la mémoire de Releasit est vide (rien n'est stocké dans
     le navigateur).
   Le thème ne fait que CLIQUER une carte d'offre (masquée par une règle CSS statique, nelya-releasit.css) et LIRE le DOM
   de Releasit : aucune ligne ajoutée, aucun texte réécrit. */
(function () {
  'use strict';
  var Nelya = window.Nelya = window.Nelya || {};
  var $$ = function (root, sel) { return [].slice.call((root || document).querySelectorAll(sel)); };
  var money = function (cents) { return window.NelyaCore ? window.NelyaCore.formatMoney(cents) : String(cents / 100); };
  function setText(nodes, value) { nodes.forEach(function (n) { n.textContent = value; }); }

  /* ---------- Bloc d'achat : nuance → variante, lots, prix, barre collante ---------- */
  Nelya.initBuyBox = function () {
    $$(document, 'form[data-buy-form]').forEach(function (form) {
      var cards = $$(form, 'label.lot');
      var section = form.closest('.shopify-section') || document;
      var sbar = section.querySelector('[data-sbar]');
      var idInput = form.querySelector('input[name="id"]');
      var root = document.documentElement;

      // variante à commander : celle de la nuance affichée (html[data-teinte], posé par nelya.js)
      function variantId() {
        return form.getAttribute(root.getAttribute('data-teinte') === 'Brun' ? 'data-variant-brun' : 'data-variant-gris');
      }
      function update() {
        var input = form.querySelector('input[name="quantity"]:checked');
        if (!input) return;
        var id = variantId();
        if (id && idInput && idInput.value !== id) {
          idInput.value = id;
          // Releasit écoute « change » sur tout le document : il relit la variante du formulaire
          idInput.dispatchEvent(new Event('change', { bubbles: true }));
        }
        cards.forEach(function (c) { c.classList.toggle('on', c.contains(input)); });
        var price = Number(input.dataset.price), compare = Number(input.dataset.compare);
        var save = compare > price ? compare - price : 0;
        setText($$(section, '[data-unit-price],[data-cta-price],[data-sbar-price]'), money(price));
        $$(section, '[data-compare]').forEach(function (n) { n.hidden = !save; });
        setText($$(section, '[data-compare-amount]'), money(compare));
        $$(section, '[data-save]').forEach(function (n) { n.hidden = !save; });
        setText($$(section, '[data-save-amount]'), money(save));
        setText($$(section, '[data-sbar-title]'), input.dataset.title);
      }
      // retour du rechargement « nuance changée » (Nelya.releasit.reload) : lot coché comme avant
      var params = new URLSearchParams(window.location.search);
      var resume = params.get('nelya_commander') === '1';
      var lotParam = resume && params.get('nelya_lot');
      if (lotParam) {
        var lotInput = form.querySelector('input[name="quantity"][value="' + lotParam.replace(/[^0-9]/g, '') + '"]');
        if (lotInput) lotInput.checked = true;
      }
      cards.forEach(function (c) { c.addEventListener('change', update); });
      document.addEventListener('nelya:teinte', update); // changement de nuance : nouvelle variante dans name="id"
      form._nelyaUpdate = update;
      update();

      // barre collante mobile : visible tant que le bouton principal n'est pas à l'écran
      var main = form.querySelector('[data-buy-submit]');
      if (sbar && main && 'IntersectionObserver' in window) {
        new IntersectionObserver(function (e) { sbar.classList.toggle('show', !e[0].isIntersecting); }).observe(main);
      }
      Nelya.releasit.bind(form);
      if (params.has('nelya_lot') || params.has('nelya_commander')) Nelya.releasit.cleanUrl();
      if (resume) Nelya.releasit.resume(form);
    });
  };

  /* ---------- Releasit COD Form ----------
     Releasit injecte dans notre formulaire un bouton ._rsi-buy-now-button-product (masqué en CSS) dont le clic sérialise
     ce formulaire (id + quantity) et ouvre #_rsi-cod-form-modal. « Comandă » (bouton, barre collante, Entrée) l'actionne.
     Repli : Releasit absent, sans bouton ou variante inconnue → soumission native (/cart/add puis checkout) ; modale jamais
     ouverte (8 s), vide (1,5 s) ou en chargement (20 s) → panier FIXÉ à la quantité du lot puis checkout. Fermeture par la
     cliente : aucun repli. */
  Nelya.releasit = {
    button: '._rsi-buy-now-button._rsi-buy-now-button-product',
    open: '#_rsi-cod-form-modal._rsi-cod-form-modal-open',
    waitButton: 2500,
    waitOpen: 8000,
    waitLoad: 20000,
    waitEmpty: 1500,
    // état de la modale : 'closed' | 'loading' | 'ready' (un champ ou un bouton d'envoi visible) | 'empty'
    state: function () {
      var m = document.querySelector(Nelya.releasit.open);
      if (!m) return 'closed';
      var vis = function (e) { return !!e && e.getBoundingClientRect().height > 0; };
      if (vis(m.querySelector('._rsi-modal-loading-page'))) return 'loading';
      var fields = m.querySelectorAll('input:not([type=hidden]),select,textarea,button[type=submit]');
      for (var i = 0; i < fields.length; i++) if (vis(fields[i])) return 'ready';
      return 'empty';
    },
    // une autre nuance a été ouverte dans cette page : rechargement (nuance + lot), puis réouverture automatique
    reload: function (form, id) {
      var pack = form.querySelector('input[name="quantity"]:checked');
      var url = new URL(window.location.href);
      url.searchParams.set('variant', id);
      url.searchParams.set('nelya_lot', pack ? pack.value : '1');
      url.searchParams.set('nelya_commander', '1');
      window.location.replace(url.toString());
    },
    // adresse nettoyée : un nouveau rechargement ou un lien copié ne rouvre rien et ne coche aucun lot
    cleanUrl: function () {
      var url = new URL(window.location.href);
      url.searchParams.delete('nelya_lot');
      url.searchParams.delete('nelya_commander');
      if (window.history.replaceState) window.history.replaceState(window.history.state, '', url.toString());
    },
    // après ce rechargement : ouverture une fois la page chargée (load) et Releasit prêt, plus 1 s. Ouvert plus tôt,
    // pendant son initialisation, Releasit ne vide plus le panier à la fermeture : la commande suivante s'y ajouterait.
    // Abandon si la cliente change la nuance ou le lot entre-temps, ou si Releasit n'est pas prêt en 10 s.
    resume: function (form) {
      var t0 = Date.now(), cancelled = false;
      var cancel = function () { cancelled = true; };
      form.addEventListener('change', cancel, { once: true });
      document.addEventListener('nelya:teinte', cancel, { once: true });
      (function wait() {
        if (cancelled) return;
        if (document.readyState === 'complete' && window._rsi && form.querySelector(Nelya.releasit.button)) {
          return setTimeout(function () {
            if (cancelled) return;
            if (form.requestSubmit) form.requestSubmit(); else form.dispatchEvent(new Event('submit', { cancelable: true }));
          }, 1000);
        }
        if (Date.now() - t0 < 10000) setTimeout(wait, 150);
      })();
    },
    present: function () { return !!(window._rsi || document.querySelector('script[src*="releasit"]')); },
    knows: function (id) {
      // variante absente du cache produit Releasit → repli ; cache illisible → on laisse Releasit décider
      try {
        var c = JSON.parse(document.getElementById('rsi-cod-form-product-cache').textContent);
        var vs = (c && c.variants) || (c && c.product && c.product.variants);
        if (!vs || !vs.length) return true;
        return vs.some(function (v) { return String(v.id) === String(id); });
      } catch (err) { return true; }
    },
    bind: function (form) {
      if (form._nelyaRsi) return;
      form._nelyaRsi = true;
      var R = Nelya.releasit, busy = false;
      var opened = {}; // nuances (variantes) ouvertes dans Releasit dans cette page, formulaire prêt
      function native() { busy = false; HTMLFormElement.prototype.submit.call(form); }
      // repli après un clic Releasit : quantité FIXÉE (et non ajoutée), puis checkout : pas de doublon
      function checkout(id) {
        busy = false;
        var pack = form.querySelector('input[name="quantity"]:checked');
        var f = document.createElement('form');
        f.method = 'post'; f.action = (window.Shopify && Shopify.routes && Shopify.routes.root || '/') + 'cart';
        [['updates[' + id + ']', pack ? pack.value : '1'], ['checkout', '1']].forEach(function (kv) {
          var i = document.createElement('input'); i.type = 'hidden'; i.name = kv[0]; i.value = kv[1]; f.appendChild(i);
        });
        document.body.appendChild(f);
        HTMLFormElement.prototype.submit.call(f);
      }
      form.addEventListener('submit', function (e) {
        if (!R.present()) return; // pas d'app : achat standard
        e.preventDefault();
        if (busy || document.querySelector(R.open)) return;
        if (form._nelyaUpdate) form._nelyaUpdate(); // name="id" = nuance affichée, au moment du clic
        var id = form.querySelector('[name="id"]');
        if (!id || !R.knows(id.value)) return native();
        var lot = form.querySelector('input[name="quantity"]:checked');
        var other = Object.keys(opened).some(function (v) { return v !== id.value; });
        if (other && lot && Number(lot.value) > 1) return R.reload(form, id.value);
        busy = true;
        var t0 = Date.now();
        (function tryOpen() {
          var btn = form.querySelector(R.button);
          if (!btn || !window._rsi) return Date.now() - t0 < R.waitButton ? setTimeout(tryOpen, 100) : native();
          var pack = form.querySelector('input[name="quantity"]:checked');
          Nelya.releasitPacks.expect(pack ? Number(pack.value) : 1, pack ? Number(pack.dataset.price) : NaN);
          btn.click();
          var t1 = Date.now(), seen = false, emptySince = 0;
          (function watch() {
            var st = R.state(), t = Date.now() - t1;
            if (st === 'ready') {
              busy = false;
              opened[id.value] = true;
              Nelya.releasitPacks.sync();
              setTimeout(function () { Nelya.releasitPacks.sync(); }, 400);
              return;
            }
            if (st === 'closed' && seen) { busy = false; return; } // la cliente a fermé : on ne force rien
            if (st !== 'closed') seen = true;
            emptySince = st === 'empty' ? emptySince || Date.now() : 0;
            if ((st === 'closed' && t > R.waitOpen) || (st === 'loading' && t > R.waitLoad) ||
                (emptySince && Date.now() - emptySince > R.waitEmpty)) return checkout(id.value);
            setTimeout(watch, 150);
          })();
        })();
      });
    }
  };

  /* ---------- Releasit : offres de quantité (lots) ----------
     À CHAQUE ouverture (Releasit recrée sa modale ; il ne s'aligne sur la quantité que si elle dépasse 1, reprend
     l'offre présélectionnée ou mémorisée, et rouvre sur ×1 après le downsell), on clique la carte dont offers[].qty =
     quantité du lot (data-offer-pos = offers[].pos) et on attend que Releasit affiche la bonne quantité ET le bon total
     (total du lot, ou inférieur si la remise du downsell s'y ajoute).
     Cartes masquées par une règle CSS STATIQUE (nelya-releasit.css) ; réaffichées (html.nelya-qo-show) seulement si la
     vérification échoue. Contenu voilé pendant la sélection (html.nelya-qo-pending), 3 s au plus. État sur <html>,
     observateur sur <body> : la modale est jetable. */
  Nelya.releasitPacks = {
    want: null,
    root: document.documentElement,
    modal: function () { return document.getElementById('_rsi-cod-form-modal'); },
    expect: function (qty, price) {
      this.want = { qty: qty, price: price };
      this.opened = false; this.failed = false; this.done = null; this.rounds = 0; this.dssSeen = false;
      this.root.classList.remove('nelya-qo-show');
      this.pending(true);
      this.watch();
    },
    end: function () {
      this.want = null; this.opened = false; this.done = null;
      this.pending(false);
    },
    // voile le contenu du popup pendant la sélection ; ne reste jamais plus de 3 s
    pending: function (on) {
      var P = this;
      clearTimeout(P.pendingTimer);
      P.root.classList.toggle('nelya-qo-pending', !!on);
      if (on) P.pendingTimer = setTimeout(function () { P.root.classList.remove('nelya-qo-pending'); }, 3000);
    },
    downsell: function () { return !!(window._rsi && _rsi.dss && _rsi.dss.activeDiscount); },
    selectedQty: function (m) {
      var i = m.querySelector('._rsi-quantity-offers-selected input[name^="item_quantity"]');
      return i ? Number(i.value) : NaN;
    },
    total: function (m) {
      var v = m.querySelector('._rsi-modal-checkout-line[data-checkout-line="total"] ._rsi-modal-checkout-line-value');
      var d = v ? v.textContent.replace(/[^0-9]/g, '') : '';
      return d ? Number(d) : NaN;
    },
    ok: function (m) {
      var w = this.want, t = this.total(m), q = this.selectedQty(m);
      if (!w) return false;
      if (q !== w.qty) return false;
      if (isNaN(w.price) || isNaN(t)) return true; // méthode : total illisible accepté
      return t === w.price || (this.downsell() && t < w.price); // la remise du downsell s'ajoute à celle du lot
    },
    target: function (m) {
      var w = this.want, pos = null;
      try {
        _rsi.form.quantityOffers.currentOffer.offers.forEach(function (o) { if (Number(o.qty) === w.qty && pos === null) pos = o.pos; });
      } catch (err) { pos = null; }
      return pos === null ? null : m.querySelector('._rsi-quantity-offers-offer-container[data-offer-pos="' + pos + '"]');
    },
    finish: function (m, good) {
      this.busy = false;
      if (good) this.done = m; else { this.failed = true; this.root.classList.add('nelya-qo-show'); } // la cliente choisira
      this.pending(false);
    },
    sync: function () {
      var P = this, m = P.modal();
      if (!P.want || P.busy || P.failed || !m || !m.classList.contains('_rsi-cod-form-modal-open')) return;
      if (!window._rsi || !_rsi.s || !_rsi.s.form || _rsi.s.form.currentPage !== 'init') return;
      var cards = m.querySelectorAll('._rsi-quantity-offers-offer-container');
      if (P.done === m && P.ok(m)) return; // sélection déjà faite à cette ouverture et toujours bonne
      if (!cards.length) { P.pending(false); return; } // pas d'offres de quantité configurées
      if (++P.rounds > 3) return P.finish(m, false);
      P.busy = true;
      // clic explicite sur l'offre du lot (même si elle paraît déjà sélectionnée), puis essai des cartes une à une
      var queue = [P.target(m)].concat([].slice.call(cards)).filter(Boolean), i = 0, t0;
      (function select() {
        if (P.modal() !== m || !P.want) { P.busy = false; return; } // modale recréée ou parcours terminé
        if (i >= queue.length) return P.finish(m, false);
        var c = queue[i++].querySelector('._rsi-quantity-offers-offer');
        if (c) c.click();
        t0 = Date.now();
        (function wait() {
          if (P.modal() !== m || !P.want) { P.busy = false; return; }
          if (P.ok(m)) return P.finish(m, true);
          if (Date.now() - t0 < 3000) return setTimeout(wait, 100);
          select();
        })();
      })();
    },
    watch: function () {
      if (this.watching || !('MutationObserver' in window)) return;
      this.watching = true;
      var P = this, queued = false, current = null;
      var inner = new MutationObserver(function () { schedule(); });
      var schedule = function () {
        var m = P.modal();
        if (m !== current) {
          inner.disconnect(); current = m;
          if (m) inner.observe(m, { childList: true, subtree: true, attributes: true, attributeFilter: ['class'] });
          if (P.want) { // nouvelle modale : nouvelle sélection ; si c'est une RÉouverture (downsell…), on revoile le contenu
            P.done = null; P.rounds = 0;
            if (P.opened) { P.opened = false; P.pending(true); }
          }
        }
        if (!P.want) return;
        var open = !!m && m.classList.contains('_rsi-cod-form-modal-open');
        if (open) P.opened = true;
        else if (P.opened && (!m || _rsi.s.form.currentPage === 'closed')) {
          // fermé par la cliente : fin du parcours, SAUF downsell accepté (Releasit rouvre le popup avec sa remise)
          if (P.downsell() && !P.dssSeen) { P.dssSeen = true; P.opened = false; P.pending(true); return; }
          P.end(); return;
        }
        if (queued) return;
        queued = true;
        // Releasit passe en 'init' après avoir construit le DOM : on revérifie un court instant plus tard
        setTimeout(function () { queued = false; try { P.sync(); } catch (err) { if (window.console) console.warn('Nelya.releasitPacks', err); } }, 120);
      };
      // la modale est (re)créée en enfant direct de <body> à chaque ouverture : on suit la modale courante
      new MutationObserver(schedule).observe(document.body, { childList: true });
      schedule();
    }
  };

  // retour arrière (bfcache) : resynchronise variante et prix avec le lot coché
  window.addEventListener('pageshow', function () {
    $$(document, 'form[data-buy-form]').forEach(function (f) { if (f._nelyaUpdate) f._nelyaUpdate(); });
  });

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', Nelya.initBuyBox);
  else Nelya.initBuyBox();
})();
